export default function ComplianceDocumentRow({
  id,
  label,
  status,
  fileUrl,
  busy = false,
  reviewed = false,
  onOpenDocument,
  onApprove,
  onReupload,
}) {
  return (
    <div
      id={id}
      style={{
        display: "grid",
        gridTemplateColumns: "1fr auto",
        gap: 10,
        alignItems: "center",
        padding: 10,
        borderRadius: 12,
        border: "1px solid #e2e8f0",
        background: "#f8fafc",
      }}
    >
      <div>
        <div style={{ fontWeight: 900, color: "#0f172a", fontSize: 13 }}>
          {label}
        </div>

        <div
          style={{
            marginTop: 3,
            color: "#64748b",
            fontWeight: 800,
            fontSize: 11,
          }}
        >
          Status: {status}
        </div>

        {fileUrl ? (
          <button
            type="button"
            style={{
              marginTop: 6,
              border: "none",
              background: "transparent",
              padding: 0,
              fontSize: 12,
              fontWeight: 900,
              color: "#2563eb",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={onOpenDocument}
          >
            Open document
          </button>
        ) : null}
      </div>

      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {status === "approved" ? (
          <div
            style={{
              padding: "8px 12px",
              borderRadius: 999,
              background: "#dcfce7",
              color: "#166534",
              fontWeight: 900,
              fontSize: 12,
            }}
          >
            Approved
          </div>
        ) : (
          <button disabled={busy} style={buttonStyle(true)} onClick={onApprove}>
            Approve
          </button>
        )}

        <button
          disabled={busy}
          style={{
            ...buttonStyle(false),
            color: "#b91c1c",
            border: "1px solid #fecaca",
            background: "#fff1f2",
          }}
          onClick={onReupload}
        >
          Reupload
        </button>
      </div>
    </div>
  );
}

function buttonStyle(primary = false) {
  return {
    border: primary ? "1px solid #2563eb" : "1px solid #d8e1ea",
    background: primary ? "#2563eb" : "#fff",
    color: primary ? "#fff" : "#0f172a",
    borderRadius: 10,
    padding: "8px 12px",
    fontWeight: 900,
    fontSize: 12,
    cursor: "pointer",
  };
}